<template>
  <div class="footer">
    <div class="footer-main">
      <YorkbbsImage class="footer-logo" :src="require('@/assets/images/common/logo.jpg')" alt="约克论坛:加拿大第一中文网!"></YorkbbsImage>
      <div class="footer-center">
        <div class="footer-nav">
          <a class="footer-nav__item" :href="`/index` | hostBuild('corp')" target="_blank">About YorkBBS</a>
          <span class="footer-nav__divider"></span>
          <a class="footer-nav__item" :href="`/aboutus` | hostBuild('corp')" target="_blank">关于我们</a>
          <span class="footer-nav__divider"></span>
          <a class="footer-nav__item" :href="`/ads` | hostBuild('corp')" target="_blank">广告服务</a>
          <span class="footer-nav__divider"></span>
          <a class="footer-nav__item" :href="`/contact` | hostBuild('corp')" target="_blank">联系方式</a>
          <span class="footer-nav__divider"></span>
          <a class="footer-nav__item" href="mailto:marketing@yorkbbs.ca" target="_blank">媒体合作</a>
          <span class="footer-nav__divider"></span>
          <a class="footer-nav__item" :href="`/policy` | hostBuild('corp')" target="_blank">免责声明</a>
          <span class="footer-nav__divider"></span>
          <a class="footer-nav__item" :href="`/maps` | hostBuild('corp')" target="_blank">网站导航</a>
          <span class="footer-nav__divider"></span>
          <a class="footer-nav__item" :href="`/privacy.html` | hostBuild('www')" target="_blank">隐私权政策</a>
        </div>
        <div class="footer-concat">
          <div>广告热线：<span>416-915-5056</span><span>416-628-9108</span></div>
          <div>广告邮件：<a href="mailto:info@yorkbbs.ca">info@yorkbbs.ca</a></div>
          <div>网站管理：<a href="mailto:admin@yorkbbs.ca">admin@yorkbbs.ca</a></div>
        </div>
        <div class="footer-copyright">Copyright © 2002-{{ nowYear }} Yorkbbs.ca 约克论坛 版权所有</div>
      </div>
      <div class="footer-right">
        <div class="footer-wechat">
          <YorkbbsImage
            class="footer-wechat__qrcode"
            :src="require('@/assets/images/common/code_02.jpg')"
          ></YorkbbsImage>
          <div class="footer-wechat__text">微信公众号</div>
        </div>
        <div class="footer-download">
          <el-popover placement="left" trigger="hover">
            <div class="footer-download__android" slot="reference">
              <i class="yk-pingguo"></i>
              <span>iOS 下载</span>
            </div>
            <div class="download-card">
              <div class="download-item">
                <YorkbbsImage class="download-qrcode" :src="require('@/assets/images/corp/iphone.png')"></YorkbbsImage>
                <div class="download-text">扫一扫 进入App Store</div>
                <div class="download-text">立即下载 Yorkbbs App</div>
              </div>
            </div>
          </el-popover>
          <el-popover placement="left" trigger="hover">
            <div class="footer-download__ios" slot="reference">
              <i class="yk-anzhuo"></i>
              <span>Android 下载</span>
            </div>

            <div class="download-card">
              <div class="download-item">
                <YorkbbsImage class="download-qrcode" :src="require('@/assets/images/corp/android.png')"></YorkbbsImage>
                <div class="download-text">扫一扫 进入Google Play</div>
                <div class="download-text">立即下载 Yorkbbs App</div>
              </div>
              <div class="download-or">或</div>
              <div class="download-item">
                <YorkbbsImage class="download-qrcode" :src="require('@/assets/images/corp/apk.png')"></YorkbbsImage>
                <div class="download-text">扫一扫 手机直接下载</div>
                <div class="download-text">apk 安装包</div>
              </div>
            </div>
          </el-popover>
          <a class="footer-download__link" target="_blank" :href="`/app` | hostBuild('corp')">约克论坛APP</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nowYear: new Date().getFullYear(),
    };
  },
};
</script>
<style lang="scss" scoped>
.footer {
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
  a {
    &:hover {
      color: var(--primary-color);
    }
  }
}
.footer-main {
  width: 1170px;
  height: 152px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.footer-logo {
  width: 132px;
}
.footer-nav {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.footer-nav__item {
  font-size: 14px;
  line-height: 20px;
  color: var(--text-color-3);
  vertical-align: middle;
}
.footer-nav__divider {
  width: 1px;
  height: 10px;
  background-color: var(--text-color-3);
  margin: 0 5px;
}

.footer-concat {
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
  color: var(--text-color-3);
  margin-bottom: 10px;
  div + div {
    margin-left: 20px;
  }
  span + span {
    margin-left: 10px;
  }
}
.footer-copyright {
  font-size: 14px;
  line-height: 20px;
  color: var(--text-color-3);
}

.footer-right {
  display: flex;
  align-items: center;
}
.footer-wechat {
  margin-right: 17px;
}
.footer-wechat__qrcode {
  width: 90px;
  height: 90px;
  margin-bottom: 2px;
}
.footer-wechat__text {
  text-align: center;
  font-size: 14px;
  line-height: 20px;
  color: var(--text-color-3);
}
.footer-download {
  text-align: center;
}
.footer-download__ios,
.footer-download__android {
  margin-bottom: 11px;
  width: 150px;
  height: 36px;
  background-color: #fff;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  color: var(--text-color-6);
  i {
    margin-right: 6px;
  }
  &:hover {
    color: #e43a3a;
    border-color: #f7c4c4;
    background-color: #fcebeb;
  }
}
.footer-download__link {
  font-size: 14px;
  line-height: 20px;
  color: var(--text-color-3);
}

.download-card {
  padding: 10px 40px;
  display: flex;
}
.download-qrcode {
  width: 160px;
  height: 160px;
  margin-bottom: 8px;
}
.download-text {
  font-size: 16px;
  line-height: 22px;
  color: var(--text-color-3);
  text-align: center;
}
.download-or {
  height: 160px;
  font-size: 16px;
  color: var(--text-color-3);
  margin: 0 35px;
  display: flex;
  align-items: center;
}
</style>
